import React, { useContext } from 'react';
import { translateWithI18Next } from '@kfc-global/kfc-i18n/lib';
import ModalComponent from 'molecules/Modal';
import ScheduleOrderFormSection from 'organisms/ScheduleOrder/Presentation/ScheduleOrderFormSection';
import { TRANSLATE_MAPPING_KEY } from 'common/constants/i18nTranslateKeys';
import { getFullAddressDetails, getUpdatedStoreInfo, ParseJsonSafely } from 'common/utilities/utils';
import { DISPOSITION_KEYS, LOCAL_STORAGE_KEYS } from 'common/constants/SharedConstants';
import ReorderAccordian from '../Presentation/ReorderAccordian';
import { ButtonType } from '../../../atoms/Buttons';
import DateTimeSection from 'organisms/ScheduleOrder/Presentation/DateTimeSection';
import { isEmpty } from 'lodash';
import { UserOrderContext } from 'context/context';

const { CURRENT_STORE_INFO_STORAGE } = LOCAL_STORAGE_KEYS;
export const disableDateOption = (enableScheduleOrderFlag, dateTimeArr) =>
  enableScheduleOrderFlag ? dateTimeArr?.length <= 1 : false;
export const disableTimeOption = (enableScheduleOrderFlag, selectedDate) =>
  enableScheduleOrderFlag ? !selectedDate?.timeSlots?.length : false;
export const disableOrderAgainButton = disableOrderAgainButtonData => {
  const {
    isGenericError,
    isPastOrderValidationLoading,
    isAddItemLoading,
    enableButton,
    enableScheduleOrder,
    isFutureDateTimeOrder,
    scheduleOrderFlag,
    selectedTime,
    hasError,
    unavailableItem,
  } = disableOrderAgainButtonData;
  return (
    isGenericError ||
    isPastOrderValidationLoading ||
    isAddItemLoading ||
    !enableButton ||
    hasError.error ||
    unavailableItem?.length > 0 ||
    (enableScheduleOrder && isFutureDateTimeOrder && scheduleOrderFlag && isEmpty(selectedTime))
  );
};
export const setPlaceHolderContent = (changeScheduleOrder, serviceType) => {
  const { DELIVERY } = DISPOSITION_KEYS;
  const selectedTimeText =
    serviceType?.toUpperCase() === DELIVERY
      ? translateWithI18Next(TRANSLATE_MAPPING_KEY.SELECT_DELIVERY_TIME)
      : translateWithI18Next(TRANSLATE_MAPPING_KEY.SELECT_PICKUP_TIME);
  return changeScheduleOrder ? selectedTimeText : translateWithI18Next(TRANSLATE_MAPPING_KEY.ASAP);
};
export const getCurrentStoreInfo = userOrderState =>
  isEmpty(userOrderState?.currentStoreInfo)
    ? ParseJsonSafely(localStorage.getItem(CURRENT_STORE_INFO_STORAGE))
    : userOrderState?.currentStoreInfo;

const ReorderComponentGlobal = props => {
  const {
    closeButtonHandler,
    onChangeDisposition,
    editDeliveryLocation,
    enableButton,
    onChangeRestaurant,
    currentOrderInfo,
    onClickOrderAgain,
    orderTypeDifferentError,
    storeError,
    isGenericError,
    isPastOrderValidationLoading,
    isAddItemLoading,
    storeChanged,
    currentStoreInfo,
    enableScheduleOrderFlag,
    selectedDate,
    selectedTime,
    scheduleOrderFlag,
    hasError,
    changeDateValue,
    changeTimeValue,
    orderNowFlag,
    enableSceduleCA,
    enableScheduleMode,
    dateTimeArr,
    orderSchedulingMode,
    changeScheduleOrder,
    isFutureDateTimeOrder,
    isStoreClosed,
    storeClosedError,
    unavailableItem,
  } = props;
  const { userOrderState } = useContext(UserOrderContext);
  const disableDateOptionFlag = disableDateOption(enableScheduleOrderFlag, dateTimeArr);
  const disableTimeOptionFlag = disableTimeOption(enableScheduleOrderFlag, selectedDate);
  const { modifiedStoreData, modifiedService, modifiedDeliveryAddress } = getUpdatedStoreInfo(
    storeChanged,
    currentStoreInfo,
    currentOrderInfo,
    userOrderState,
  );
  const deliveryAddressInfo = storeChanged
    ? userOrderState?.selectedDeliveryAddress
    : getFullAddressDetails(modifiedDeliveryAddress, true);
  const {
    REVIEW_ORDER,
    ORDER_TYPE,
    ORDER_TYPE_CHANGE,
    YOUR_KFC_RESTAURANT,
    YOUR_LOCATION,
    ORDER_AGAIN,
    PICK_UP_TIME,
    DELIVERY_TIME,
  } = TRANSLATE_MAPPING_KEY;
  const { DELIVERY } = DISPOSITION_KEYS;
  const placeholderContent = setPlaceHolderContent(changeScheduleOrder, modifiedService);
  const showScheduleTime = orderNowFlag || (scheduleOrderFlag && !changeScheduleOrder);
  const showDateTime = scheduleOrderFlag && changeScheduleOrder;
  const disableOrderAgainButtonPayload = {
    isGenericError,
    isPastOrderValidationLoading,
    isAddItemLoading,
    enableButton,
    enableScheduleOrder: enableScheduleOrderFlag,
    isFutureDateTimeOrder,
    scheduleOrderFlag,
    selectedTime,
    hasError,
    unavailableItem,
  };
  return (
    <React.Fragment>
      <ModalComponent
        id='ReOrderModal'
        role='dialog'
        ariaLabel='Close Start your Order dialog'
        modalTitleId={'re-order-id'}
        show={true}
        classNames='reorder-modal-global extra-small-modal'
        showCloseBtn={true}
        closeButtonHandler={closeButtonHandler}
        backButtonHandler={closeButtonHandler}
        modalTitle={translateWithI18Next(REVIEW_ORDER)}
        closeDataTestId='close-modal-handler'
        showBackBtn={true}
        showFooterSection={true}
        buttonVariant={ButtonType.secondary}
        footerBtnText={translateWithI18Next(ORDER_AGAIN)}
        footerBtnHandler={onClickOrderAgain}
        footerBtnTestId={'reorder-order-it-again'}
        disabledBtn={disableOrderAgainButton(disableOrderAgainButtonPayload)}
        loadingBtn={isAddItemLoading}
      >
        <ScheduleOrderFormSection
          show
          sectionHeader={ORDER_TYPE}
          subSectionValue={translateWithI18Next(modifiedService)}
          orderTypeChange={ORDER_TYPE_CHANGE}
          onClickHandler={onChangeDisposition}
          storeUnavailableError={orderTypeDifferentError}
          isAlert={true}
        />
        <ScheduleOrderFormSection
          show={modifiedService.toUpperCase() === DELIVERY}
          sectionHeader={YOUR_LOCATION}
          subSectionValue={deliveryAddressInfo}
          description={
            modifiedDeliveryAddress?.addressLines >= 1
              ? modifiedDeliveryAddress?.addressLines?.[0]
              : userOrderState?.deliveryAddressLineVal
          }
          orderTypeChange={ORDER_TYPE_CHANGE}
          onClickHandler={() => editDeliveryLocation(deliveryAddressInfo)}
        />
        <ScheduleOrderFormSection
          show
          sectionHeader={YOUR_KFC_RESTAURANT}
          subSectionValue={modifiedStoreData?.name}
          orderTypeChange={ORDER_TYPE_CHANGE}
          onClickHandler={onChangeRestaurant}
          isAlert={isStoreClosed || !isGenericError}
          storeUnavailableError={(isGenericError && storeError) || (isStoreClosed && storeClosedError)}
        />
        <ScheduleOrderFormSection
          show={Boolean(enableScheduleOrderFlag && showScheduleTime)}
          sectionHeader={modifiedService.toUpperCase() === DELIVERY ? DELIVERY_TIME : PICK_UP_TIME}
          subSectionValue={orderSchedulingMode}
          orderTypeChange={ORDER_TYPE_CHANGE}
          onClickHandler={enableScheduleMode}
          showChangeButton={enableSceduleCA}
        />
        <DateTimeSection
          show={Boolean(enableScheduleOrderFlag && showDateTime)}
          sectionHeader={modifiedService.toUpperCase() === DELIVERY ? DELIVERY_TIME : PICK_UP_TIME}
          subSectionValue={modifiedStoreData?.name}
          orderTypeChange={ORDER_TYPE_CHANGE}
          changeDateValue={changeDateValue}
          changeTimeValue={changeTimeValue}
          dateTimeArr={dateTimeArr}
          selectedDate={selectedDate}
          selectedTime={selectedTime}
          placeholderText={placeholderContent}
          disableDateOption={disableDateOptionFlag}
          disableTimeOption={disableTimeOptionFlag}
          scheduleTimeWarning={enableScheduleOrderFlag && hasError && hasError?.error}
          scheduleErrMsg={enableScheduleOrderFlag && hasError && hasError?.errormessage}
          enableScheduleOrderFlag={enableScheduleOrderFlag}
        />
        <ReorderAccordian {...props} />
      </ModalComponent>
    </React.Fragment>
  );
};

export default ReorderComponentGlobal;
